import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { projects } from '../data/projects';
import './Home.css';

const Home = () => {
  const featuredProjects = projects.slice(0, 3);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero section-padding">
        <div className="container-narrow">
          <h1 className="hero-large">Megha Mehta</h1>
          <p className="hero-subtitle">Creative Head, Stylist, Visual Strategist</p>
          <p className="hero-description body-large">
            I shape fashion narratives into consistent visual systems for modern brands.
          </p>
          
          {/* Hero Image Block */}
          <div className="hero-image-block">
            <img 
              src="https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/o6qfmqjx_WhatsApp%20Image%202026-01-22%20at%2017.01.20.jpeg"
              alt="Megha Mehta"
              className="hero-image"
            />
          </div>
          
          <div className="hero-actions">
            <Link to="/work" className="btn-primary accent">
              View Work
            </Link>
            <Link to="/experience" className="btn-primary">
              Experience
            </Link>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="intro section-padding-small">
        <div className="container-narrow">
          <p className="body-large">
            I work at the intersection of fashion, storytelling, and commercial clarity. 
            My focus is on creating visuals that feel intuitive, refined, and purposeful, 
            not only aesthetically compelling, but strategically aligned.
          </p>
          <p className="body-large" style={{ marginTop: '32px' }}>
            I believe the most effective fashion imagery feels effortless, even when it is meticulously built.
          </p>
        </div>
      </section>

      {/* What I Do Section */}
      <section className="what-i-do section-padding-small">
        <div className="container">
          <h2 className="heading-1 section-title">What I Do</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3 className="heading-3">Creative Direction</h3>
              <p className="body-regular">Building cohesive visual narratives across campaigns, platforms, and seasons.</p>
            </div>
            <div className="service-item">
              <h3 className="heading-3">Styling & Visual Language</h3>
              <p className="body-regular">Translating brand identity into repeatable, scalable styling systems.</p>
            </div>
            <div className="service-item">
              <h3 className="heading-3">E-commerce Content Strategy</h3>
              <p className="body-regular">Developing efficient workflows that balance quality with commercial demands.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy section-padding-small">
        <div className="container-narrow">
          <h2 className="heading-1 section-title">Philosophy</h2>
          <div className="philosophy-content">
            <p className="hero-medium philosophy-text">Fashion isn't only about trends.</p>
            <p className="hero-medium philosophy-text">It's about consistency.</p>
            <p className="hero-medium philosophy-text">Clarity.</p>
            <p className="hero-medium philosophy-text">And emotion.</p>
            <p className="body-large" style={{ marginTop: '48px' }}>
              I build visual systems that feel natural and work commercially.
            </p>
          </div>
        </div>
      </section>

      {/* Work Preview - TEXT ONLY */}
      <section className="selected-work section-padding">
        <div className="container">
          <div className="projects-text-grid">
            {featuredProjects.map((project) => (
              <div key={project.id} className="project-text-card">
                <h3 className="heading-3">{project.name}</h3>
                <p className="body-small project-meta">{project.role} · {project.year}</p>
                <p className="body-regular project-excerpt">{project.context}</p>
              </div>
            ))}
          </div>
          <div className="view-all-wrapper">
            <Link to="/work" className="btn-link">
              <span>View All Work</span>
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* Experience Teaser */}
      <section className="experience-teaser section-padding-small">
        <div className="container-narrow">
          <h2 className="heading-1 section-title">Experience</h2>
          <p className="body-large" style={{ marginBottom: '32px' }}>
            A decade of shaping fashion narratives across brands, platforms, and formats.
          </p>
          <Link to="/experience" className="btn-primary">
            View Full Experience
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
